import { render, staticRenderFns } from "./OrderPropertyValueListItem.vue?vue&type=template&id=2b06b088"
import script from "./OrderPropertyValueListItem.vue?vue&type=script&lang=js"
export * from "./OrderPropertyValueListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports